import AuthLayout from '@/views/layout/auth';
import AuthLoginPage from '@/views/pages/auth/login';
import AuthRecoverPage from '@/views/pages/auth/recover';
import AuthRegisterPage from '@/views/pages/auth/register';
import AuthResetPage from '@/views/pages/auth/reset';

export const authRoutes = [
    {
        path: '/auth',
        component: AuthLayout,
        redirect: '/auth/login',
        children: [
            {path: 'login', component: AuthLoginPage, meta: {middleware: 'guest'}},
            {path: 'register', component: AuthRegisterPage, meta: {middleware: ['guest', 'register']}},
            {path: 'recover', component: AuthRecoverPage, meta: {middleware: 'guest'}},
            {path: 'reset/:token', component: AuthResetPage, meta: {middleware: 'guest'}},
        ],
    },
];
